/**
 * EgpStepID
 */
class EgpStepID {
  static START = 0
  static LOGIN = 0
  static UPLOAD = 1
  static MESSAGE_SENT = 2
  static UPLOAD_SUCCESS = 3
  static UPLOAD_FAILED = 4
}

export default EgpStepID;
